import React from "react";
import PropTypes from "prop-types";
import Article from "../entities/article";
import ArticleBoxThumbnail from "./ArticleBoxThumbnail";

function PrArticleBox({ article }) {
  const articleEntity = new Article({ ...article });
  const userIconUrl = articleEntity.user?.icon_url;

  return (
    <div className="m_prBox">
      <a
        className="p_icon isRight"
        href={`/job/articles/${articleEntity.id}?pr_content=true`}
      >
        <span className="smallLabel">こちらもオススメ</span>
        <div className="prHead clearFix">
          <ArticleBoxThumbnail
            imageUrl={articleEntity.medium_pic_url}
            userIconUrl={userIconUrl}
            showUserIconBackground={false}
          />
          <h4>{articleEntity.title}</h4>
        </div>
        <p>{articleEntity.description}</p>
      </a>
    </div>
  );
}

PrArticleBox.propTypes = {
  article: PropTypes.instanceOf(Article).isRequired,
};

export default PrArticleBox;
